import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sample-report',
  templateUrl: './sample-report.component.html',
  styleUrls: ['./sample-report.component.scss']
})
export class SampleReportComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<SampleReportComponent>) { }

  ngOnInit(): void {
  }

  proceedCancelAction(): void {
    this.dialogRef.close();
  }

}
